<template>
    <option value="active">Active</option>
    <option value="paused">Paused</option>
    <option value="inactive">Inactive</option>
</template>
